package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.MERCHANT_RESET_PASSWORD
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class ResetPasswordRequestModel(
    val email: String,
    val temporaryPassword: String,
    val newPassword: String
) : BaseRequestModel(api = MERCHANT_RESET_PASSWORD)
